/**
 * A collection of helper functions
 *
 * @packageDocumentation
 * @category Util
 */

import { parseJSON } from 'BomdisoftUtilities/functions';
// #region imports
import { EventObject, InspectionEvent, MachineContext, StateMachine } from 'xstate';
// #endregion

export const persistMachineSnapshot = (storageKey: string, version?: number) => (event: InspectionEvent) => {
  if (typeof localStorage == 'undefined') return;
  if (event.type === '@xstate.snapshot') {
    const persistedState = event.actorRef.getSnapshot();
    if (persistedState.context) localStorage.setItem(storageKey, JSON.stringify({ __version: version, snapshot: persistedState }));
  }
};

export const restoreMachineSnapshot =
  <C extends MachineContext, E extends EventObject>(storageKey: string, machine: StateMachine<C, E, any, any, any, any, any, any, any, any, any, any, any, any>, version?: number) =>
  () => {
    if (typeof localStorage === 'undefined') return undefined;

    const stored = parseJSON(localStorage.getItem(storageKey));
    if (!stored) return undefined;

    const restoredState = stored.__version !== undefined ? stored.snapshot : stored;
    if (!restoredState?.context || stored.__version !== version) {
      localStorage.removeItem(storageKey);
      return undefined;
    }

    try {
      const resolvedState = machine.resolveState(restoredState);
      resolvedState.status = 'active';
      return resolvedState;
    } catch {
      localStorage.removeItem(storageKey);
      return undefined;
    }
  };
